import apiStore from '@/api/seller/store';

const defaultState = () => ({
	loadStore: false,
	detailStore: null,
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: '',
	sellerMenuMini: false,
	latitude: null,
	longitude: null,
});

const state = defaultState();

const getters = {
	isStoreB2b(state) {
		let isb2b = false
		if (state.detailStore) {
			if (state.detailStore.store_is_b2b == 'true') {
				isb2b = true
			}
		}
		return isb2b
	}
};

const mutations = {
	setLatLon(state, data) {
		state.latitude = data.latitude
		state.longitude = data.longitude
	},
	setloadStore(state, data) {
		state.loadStore = data
	},
	setStoreDetail(state, data) {
		state.detailStore = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearStore(state) {
		Object.assign(state, defaultState());
	},
	sellerMenu() {
		state.sellerMenuMini = !state.sellerMenuMini
	}
};

const actions = {
	async actLatLon({ commit }, params) {
		commit('setLatLon', params);
	},
	changeSellerMenu({ commit }) {
		commit('sellerMenu')
	},
	getStoreDetail({ commit }, params) {
		commit('setloadStore', true);
		return new Promise((resolve, reject) => {
			apiStore.getStoreDetail(params).then(({ data: { data } }) => {
				commit('setStoreDetail', data.results);
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				commit('makeAlert', { code: 'error_response', type: 'error', message: data.message, show: true }, { root: true });
				commit('setStoreDetail', {});
				reject(true)
			}).then(() => {
				commit('setloadStore', false);
			});
		});
	},
	updateStore({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStore.updateStore(params).then(({ data }) => {
				dispatch('success', data)
				resolve(true);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	updateStoreCourier({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStore.updateStoreCourier(params).then(({ data }) => {
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	updateStoreBank({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStore.updateStoreBank(params).then((data) => {
				dispatch('success', data.data)
				resolve(data.data)
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	uploadImage({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStore.uploadImage(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data.data.results.store_image);
			}).catch((err) => {
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	saveDescription({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStore.saveDescription(params).then(({ data }) => {
				dispatch('success', data)
				resolve(data);
			}).catch((err) => {
				console.log(err)
				const { data } = err.response;
				dispatch('errorHandler', data);
				reject(true)
			})
		});
	},
	async success({ commit }, response) {
		await commit('saveResponse', response)
		await commit('makeAlert', { code: 'success', type: 'success', message: response.message, show: true }, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};